export const FORMAT_DATE = 'MMMM D, YYYY';
export const FORMAT_EDIT_DATE = 'MM/DD/YYYY';
export const FORMAT_DATE_TIME = 'MMM DD, h:mm A';

export const CALENDAR_TITLE_DAY_FORMAT = 'dddd, MMMM DD, YYYY';
export const CALENDAR_TITLE_WEEK_FORMAT_START = 'MMM DD';
export const CALENDAR_TITLE_WEEK_FORMAT_END = 'MMM DD, YYYY';
export const CALENDAR_TITLE_MONTH_FORMAT = 'MMMM YYYY';
export const CALENDAR_TITLE_YEAR_FORMAT = 'YYYY';
export const CALENDAR_TITLE_DAY_SHORT_FORMAT = 'ddd';
export const CALENDAR_TITLE_DATE_SHORT_FORMAT = 'MM/DD';
export const CALENDAR_TITLE_MONTH_DAY_FORMAT = 'dddd';
export const CALENDAR_MONTH_EVENT_TIME_FORMAT = 'h:mmA';

export const CALENDAR_DAY_CELL_FORMAT = 'D';

export const CALENDAR_YEAR_MONTH_NAME_FORMAT = 'MMMM';
export const CALENDAR_EVENT_SHORT_DATE_FORMAT = 'hA';
export const CALENDAR_EVENT_DATE_FORMAT = 'h:mmA';

export const CALENDAR_SHORT_DAY_FORMAT = 'dd';
export const CALENDAR_FULL_FORMAT = 'dddd, MMMM DD, YYYY';

export const FIRST_DAY_OF_WEEK_DEFAULT = 0; // Sunday

export const TIME_PICKER_MINUTES_STEP = 15;

export const FORMAT_DATE_TIME_ISO_NO_TZ = 'YYYY-MM-DDTHH:mm:ss';
